export const CANT_CHANGE_ORDER_MESSAGE_PENDING = () => 'Your delivery is just about to be sent out so you cannot make changes right now.';
export const CANT_CHANGE_ORDER_MESSAGE_DISPATCHED = () => 'Your delivery was sent out so you cannot make changes right now.';

export const INVALID_PASSWORD_MESSAGE = 'Sorry, that password doesn\'t meet the security requirements. Please try again';
export const INCORRECT_PASSWORD_MESSAGE = 'Sorry, the password is incorrect. Please try again';
export const PASSWORD_RETYPE_MISMATCH_MESSAGE = 'Sorry, the passwords you have entered do not match. Please try again';
// Checkboxes
export const MAKE_THIS_MY_DELIVERY_TITLE = () => 'Make this my delivery address';
export const MAKE_THIS_MY_DELIVERY_SINGLE_SUB_TEXT = () => 'All future deliveries will be sent to this address once you confirm the change. ' +
  'In the event you change your address, you must notify Specsavers\n' +
  'at the earliest opportunity or at the very latest, within thirty (30) calendar\n' +
  'days of the next Supply Pack due to you.';
export const MAKE_THIS_MY_DELIVERY_MULTIPLE_SUB_TEXT = () => 'All future deliveries will be sent to this address. These changes will only affect this subscription.';
export const MAKE_THIS_MY_PRIMARY_ADDRESS_TEXT = () => 'This will be used as your main address for all Specsavers correspondence.';
export const MAKE_THIS_MY_PRIMARY_ADDRESS_TITLE = () => 'Make this my primary address';

export const CONFIRM_I_HOLD_A_UK_ACCOUNT_HOLDER_TEXT = () => 'I can confirm that I hold a UK Bank/Building Society and that I am the account holder';
export const CONFIRM_I_AM_THE_ONLY_PERSON_REQUIRED_TEXT = () => 'I can confirm that I am the only person required to authorise debits on this account';
export const CONFIRM_IT_IS_NOT_A_BUSINESS_ACCOUNT_TEXT = () => 'I can confirm that this is not a business account or one that requires more than one signature';
// Confirmation messages

/*

APPLY_ALL  | PRIMARY | MULTI |
------------------------------------------
0          | 0       | 0     | N/A
0          | 0       | 1     | N/A
0          | 1       | 0     | SAVE_ADDRESS_CONFIRMATION_PRIMARY
0          | 1       | 1     | SAVE_ADDRESS_CONFIRMATION_PRIMARY
1          | 0       | 0     | SAVE_ADDRESS_CONFIRMATION_APPLY_ALL_SINGLE
1          | 0       | 1     | SAVE_ADDRESS_CONFIRMATION_APPLY_ALL_MULTI
1          | 1       | 0     | SAVE_ADDRESS_CONFIRMATION_APPLY_ALL_PRIMARY_SINGLE
1          | 1       | 1     | SAVE_ADDRESS_CONFIRMATION_APPLY_ALL_PRIMARY_MULTI
*/
const SAVE_ADDRESS_CONFIRMATION_PRIMARY = 'All done. You\'ve changed your primary address for future correspondence.';
const SAVE_ADDRESS_CONFIRMATION_APPLY_ALL_SINGLE = 'All done. You\'ve changed your delivery address for all future deliveries.';
const SAVE_ADDRESS_CONFIRMATION_APPLY_ALL_MULTI = 'All done. You\'ve changed your delivery address for all future deliveries. These changes will only affect this subscription.';
const SAVE_ADDRESS_CONFIRMATION_APPLY_ALL_PRIMARY_SINGLE = 'All done. You\'ve changed your primary address for future correspondence and all future deliveries.';
const SAVE_ADDRESS_CONFIRMATION_APPLY_ALL_PRIMARY_MULTI = 'All done. You\'ve changed your primary address for future correspondence. All future deliveries for this subscription will also go to this address.';

export const SAVE_ADDRESS_CONFIRMATION = (applyToAll, makePrimary, multi) => (
  (!applyToAll && makePrimary && SAVE_ADDRESS_CONFIRMATION_PRIMARY)
  || (applyToAll && !makePrimary && !multi && SAVE_ADDRESS_CONFIRMATION_APPLY_ALL_SINGLE)
  || (applyToAll && !makePrimary && multi && SAVE_ADDRESS_CONFIRMATION_APPLY_ALL_MULTI)
  || (applyToAll && makePrimary && !multi && SAVE_ADDRESS_CONFIRMATION_APPLY_ALL_PRIMARY_SINGLE)
  || (applyToAll && makePrimary && multi && SAVE_ADDRESS_CONFIRMATION_APPLY_ALL_PRIMARY_MULTI)
);

export const SAVE_ADDRESS_PACK_CONFIRMATION = (deliveryDate, makePrimary) => `All done. You've changed your delivery address for the ${deliveryDate} delivery${makePrimary ? ' and your primary address for future correspondence' : ''}.`;
export const SAVE_ADDRESS_CHANGE_DELAYED_TEXT = () => 'Because a package is already on its way to you, this new delivery address will not apply until the following delivery. Check the box to let us know you\'re happy to continue and we\'ll update the details.';

export const DELETE_ADDRESS_CONFIRMATION = 'Address deleted successfully.';
export const DELETE_ADDRESS_IN_USE_RESPONSE_FAILURE = 'This address is currently in use and the action cannot be performed.';
export const DELETE_ADDRESS_DEFAULT_RESPONSE_FAILURE = 'This address is currently default and cannot be deleted.';

export const PAYMENT_VALIDATION_RESPONSE_FAILURE = 'Account details not valid. Please check and try again.';
export const PAYMENT_SERVICE_FAILURE = 'Service is not available. Please try again later.';
export const UPDATE_PAYMENT_SERVICE_FAILURE = 'Update could not be completed. Please try again later.';

export const COUNTRY_IE = 'Ireland';
export const COUNTRY_UK = 'United Kingdom';
export const COUNTRY_BFPO = 'BFPO';
export const COUNTRY_GUERNSEY = 'Guernsey';
export const COUNTRY_JERSEY = 'Jersey';

export const ADD_NEW_ADDRESS_INFO = (taxCode) => ({
  'GBH': 'We can only deliver to UK and BFPO addresses',
  'IEH': 'We can only deliver to Ireland and BFPO addresses',
  'GYH': 'We can only deliver to Guernsey and BFPO addresses',
  'JEH': 'We can only deliver to Jersey and BFPO addresses',
  }[taxCode]);

export const SAVE_ADDRESS_UK_COUNTRY_ERROR = 'Due to your store location we can only deliver to UK and BFPO addresses';
export const SAVE_ADDRESS_IE_COUNTRY_ERROR = 'Due to your store location we can only deliver to ROI and BFPO addresses';
export const SAVE_ADDRESS_GUERNSEY_COUNTRY_ERROR = 'Due to your store location we can only deliver to Guernsey and BFPO addresses';
export const SAVE_ADDRESS_JERSEY_COUNTRY_ERROR = 'Due to your store location we can only deliver to Jersey and BFPO addresses';
